import { render, staticRenderFns } from "./EditDoc.vue?vue&type=template&id=0acd1236&scoped=true"
import script from "./EditDoc.vue?vue&type=script&lang=js"
export * from "./EditDoc.vue?vue&type=script&lang=js"
import style0 from "./EditDoc.vue?vue&type=style&index=0&id=0acd1236&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0acd1236",
  null
  
)

export default component.exports